import React, {useState, useEffect, useRef} from 'react';
import {Container, Row, Col, Toast, Button, Card, OverlayTrigger, Tooltip, Spinner} from 'react-bootstrap';
import './MonitoringPage.css';
import 'react-dropdown/style.css';
import {MonitoringService} from "./MonitoringService";
import AlertsHistoryTable from "../../Components/AlertsTable/AlertsHistoryTable";
import SearchDropDown from "./SearchDropDown";
import DateRangePicker from "../../Components/ReportsGeneratorComponents/DateRangePicker/DateRangePicker";
import {getLastMonthEndDate, getLastMonthStartDate} from "../../Components/ReportsGeneratorComponents/Utils/utils";
import moment from "moment/moment";
import {BiCog} from "react-icons/bi";
import {BsCheckCircleFill} from "react-icons/bs";
import OrganizationSettingModal from "./OrganizationSettingsModal";

export default function MonitoringHistoryPage() {
    const sitesFilterValue = useRef([]);
    const allMonitoringData = useRef([]);
    const [alertTableData, setAlertTableData] = useState(null);
    const [originalAlertTableData, setOriginalAlertTableData] = useState(null);
    const [siteFilter, setSiteFilter] = useState(sitesFilterValue.current);
    const [confirmationFilterOptions, setConfirmationFilterOptions] = useState([]);
    const [reasonChanged, setReasonChanged] = useState([]);
    const [reasonsOptions, setReasonsOptions] = useState([]);
    let confirmationData = [];
    const [showPopup, setShowPopup] = useState(false);
    const [showExcludePopup, setShowExcludedPopup] = useState(false);
    const [excludedPopupText, setExcludedPopupText] = useState('');
    const [fadingOut, setFadingOut] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isSetButtonClicked, setIsSetButtonClicked] = useState(false);
    const [siteData, setSiteData] = useState([]);
    const monitoringService = new MonitoringService(process.env.REACT_APP_SUPPORT_DASHBOARD_LEAKS_URL);
    const monitoringHistorySummaryService = new MonitoringService(process.env.REACT_APP_SUPPORT_DASHBOARD_REPORT_URL);
    const [startDate, setStartDate] = useState(getLastMonthStartDate());
    const [endDate, setEndDate] = useState(getLastMonthEndDate());
    const [dateApplied, setDateApplied] = useState(false);
    const [organizationId, setOrganizationId] = useState(null);
    const [potentialLeakVolume, setPotentialLeakVolume] = useState(0);
    const [actualLeakVolume, setActualLeakVolume] = useState(0);
    const [numberOfLeakAlerts, setNumberOfLeakAlerts] = useState(0);
    const [totalWaterConsumption, setTotalWaterConsumption] = useState(0);
    const [leakVolumePercentage, setLeakVolumePercentage] = useState(0);
    const [potentialLeakVolumePercentage, setPotentialLeakVolumePercentage] = useState(0);
    const [organizationLeakDuration, setOrganizationLeakDuration] = useState('');
    const [organizationLeakFlowRate, setOrganizationLeakFlowRate] = useState('');
    const [organizationLeakVolume, setOrganizationLeakVolume] = useState('');
    const [isErrorDetected, setIsErrorDetected] = useState(false);
    const [isSummaryDataLoading, setIsSummaryDataLoading] = useState(false);
    const [isOrganizationSelected, setIsOrganizationSelected] = useState(false);
    const ERROR_MSG = 'Error encountered, please try again later';
    const [osmShow, setOsmShow] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [isTableMounted, setIsTableMounted] = useState(false);
    const MAX_SUMMARY_CHAR_LIMIT = 16;
    const ORGANIZATION_LEVEL_FILTER_TITLE = 'Default Organization Level Filter';
    const reasonsArr = [
        {id: 1, text: '', confirmation: "UNKNOWN"},
        {id: 2, text: "Burst pipe", confirmation: "CONFIRMED_LEAK"},
        {id: 3, text: "Running toilet", confirmation: "CONFIRMED_LEAK"},
        {id: 4, text: "Open tap", confirmation: "CONFIRMED_LEAK"},
        {id: 5, text: "Unknown alert cause", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 6, text: "Other", confirmation: "CONFIRMED_LEAK"},
        {id: 7, text: "Background flow", confirmation: "CONFIRMED_LEAK"},
        {id: 8, text: "Drip", confirmation: "CONFIRMED_LEAK"},
        {id: 9, text: "Stuck float valve", confirmation: "CONFIRMED_LEAK"},
        {id: 10, text: "Bug", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 11, text: "Incorrect meter configuration", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 12, text: "Incorrect algo thresholds", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 13, text: "Legitimate high usage", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 14, text: "Incorrect policy parameters", confirmation: "CONFIRMED_FALSE_ALERT"}
    ];

    const confirmations = [
        {id: 0, value: 'UNKNOWN'},
        {id: 1, value: 'CONFIRMED_LEAK'},
        {id: 2, value: 'CONFIRMED_FALSE_ALERT'}
    ];

    const notificationLevels = [
        {value: 'LB3_LEAK_NOTIFLEVEL_OFF', label: 'End of leak'},
        {value: 'LB3_LEAK_NOTIFLEVEL_NOTIFY', label: 'First Notification'},
        {value: 'LB3_LEAK_NOTIFLEVEL_WARNING', label: 'Warning'},
        {value: 'LB3_LEAK_NOTIFLEVEL_CLOSE', label: 'Close'},
        {value: 'LB3_LEAK_SEVERE', label: 'Severe leak'},
    ];

    const leakTypes = [
        {value: 'MAJOR', label: 'Major'},
        {value: 'MODERATE', label: 'Moderate'},
        {value: 'MINOR', label: 'Minor'}
    ];

    const verticalLineStyle = {
        width: '1px', height: '36px', float: 'left', backgroundColor: 'rgba(0,0,0,.5)', margin: '5px'
    };

    const handleOnEdit = (state) => {
        setIsEditing(state);
    }
    const getOrganizationFilterRulesValues = async () => {
        setIsErrorDetected(false);
        try {
            const response = await monitoringService.getOrganizationLevelFilterRules(organizationId);
            let data = response.data;
            if (!data) {
                setIsErrorDetected(true);
                console.error(`Data from OrganizationLevelFilterRules is empty`);
                return;
            }
            setOrganizationLeakFlowRate(data.flowrate);
            setOrganizationLeakDuration(data.duration);
            setOrganizationLeakVolume(data.volume);
        } catch (e) {
            if (e.response.status !== 404) {
                setIsErrorDetected(true);
            }
            console.error(`Error getting data from OrganizationLevelFilterRules`);
        }

    }

    const getEventHistorySummaryData = async () => {
        const utcStartDate = moment(startDate).startOf('day').toISOString().slice(0, -5);
        const utcEndDate = moment(endDate).endOf('day').toISOString().slice(0, -5);
        let data = null;
        setIsErrorDetected(false);
        setIsSummaryDataLoading(true);
        try {
            const response = await monitoringHistorySummaryService.getLeakHistorySummaryData(utcStartDate, utcEndDate, organizationId);
            setIsSummaryDataLoading(false);
            data = response.data;
        } catch (error) {
            setIsSummaryDataLoading(false);
            setIsErrorDetected(true);
            console.error(`Error getting data from EventHistorySummaryData`);
            return;
        }
        if (!data) {
            setIsErrorDetected(true);
            console.error(`Data from EventHistorySummaryData is empty`);
            return;
        }
        setNumberOfLeakAlerts(data.numberOfInactiveLeakAlerts);
        setActualLeakVolume(data.actualInactiveLeakVolume);
        setPotentialLeakVolume(data.potentialInactiveLeakVolume);
        setTotalWaterConsumption(data.totalWaterConsumption);
        setLeakVolumePercentage(data.actualInactiveLeakVolumePercentage);
        setPotentialLeakVolumePercentage(data.potentialInactiveLeakVolumePercentage);
    }

    const getEventHistoryData = async () => {
        const utcStartDate = moment(startDate).startOf('day').toISOString().slice(0, -5);
        const utcEndDate = moment(endDate).endOf('day').toISOString().slice(0, -5);
        let siteIdString = '';
        siteFilter.forEach(obj => {
            siteIdString = siteIdString.concat(obj.value + ",");
        })
        siteIdString = siteIdString.substring(0, siteIdString.length - 1);
        setIsErrorDetected(false);
        const response = await monitoringService.getInactiveLeaks(utcStartDate, utcEndDate, organizationId, siteIdString);
        setIsSetButtonClicked(false);
        let data = response.data;
        if (!data) {
            setIsErrorDetected(true);
            console.error(`Data from EventHistoryClosedLeaks is empty`);
            return;
        }
        allMonitoringData.current = data;
    }

    const formatDate = (date) => {
        if (!date) {
            return '';
        }
        const formattedString = moment.utc(date).format('lll');
        return formattedString === 'Invalid date' ? '' : formattedString;
    }

    // Init the Alerts Table
    const initAlertTable = (data) => {
        let alertTableData = [];
        data.forEach(event => {
            alertTableData.push({
                id: event.id,
                assignee: event.assignee,
                communication: event.communication,
                remarks: event.remarks,
                siteName: event.site.name,
                siteId: event.site.id,
                linkToSalesForce: event.linkToSalesForce,
                excluded: event.excluded ? event.excluded : false,
                waterSystemName: event.waterSystem.name,
                waterSystemId: event.waterSystem.id,
                rawData: event.basedOnRawData,
                leakType: getLeakType(event.flowRateType),
                level: getNotificationLevel(event.level),
                leakStartTime: formatDate(event.startTime),
                endOfLeak: formatDate(event.endTime),
                leakFlowRate: event.leakStats.flowrate,
                readableActualDuration: event.leakStats.duration,
                actualLeakVolume: event.leakStats.volume,
                readablePotentialLeakDuration: event.potentialLeakStats.duration,
                potentialLeakVolume: event.potentialLeakStats.volume,
                leakCount: event.leakCount,
                confirmation: getConfirmation(event.confirmation),
                reason: getReasonId(event.reason)
            })
        })
        setOriginalAlertTableData(alertTableData);
        setAlertTableData(alertTableData);
        setFilteredData(alertTableData);
    }

    const getReasonId = (reason) => {
        if (!reason) {
            return 1;
        }
        let readableText = reason.replaceAll('_', ' ').toLowerCase();
        readableText = reason.charAt(0) + readableText.slice((1))
        const result = reasonsArr.filter((obj) => obj.text === readableText)
        return result[0] ? result[0].id : 1;
    }

    const getLeakType = (leakType) => {
        const result = leakTypes.filter((obj) => obj.value === leakType)
        return result[0] ? result[0].label : '';
    }

    const getNotificationLevel = (notificationLevel) => {
        const result = notificationLevels.filter((obj) => obj.value === notificationLevel)
        return result[0] ? result[0].label : '';
    }

    const getConfirmation = (confirmation) => {
        const result = confirmations.filter((obj) => obj.value === confirmation)
        return result[0] ? result[0].id : 0;
    }

    const getSitesData = async () => {
        let sites = [];
        let response = await monitoringService.getSitesByOrganization(organizationId);
        if (!response.data) {
            console.error(`Sites Data from EventHistoryClosedLeaks is empty`);
            return;
        }
        response.data.forEach(obj => {
            sites.push({value: obj.id, label: obj.label});
        })
        setSiteData(sites);
    }

    const getAllData = async () => {
        let confirmations = [];
        let reasons = [];

        reasonsArr.forEach(reason => {
            let value = 0;
            if (reason.confirmation === "CONFIRMED_LEAK") {
                value = 1;
            } else if (reason.confirmation === "CONFIRMED_FALSE_ALERT") {
                value = 2;
            }

            const label = reason.confirmation.replaceAll('_', ' ').toLowerCase();
            confirmations.push({
                id: reason.id, value: value, label: reason.confirmation.charAt(0) + label.slice((1)), text: reason.text
            });
            reasons.push({confirmationValue: value, label: reason.text, value: reason.text});
        })
        setConfirmationFilterOptions(confirmations);
        setReasonsOptions(reasons);
        confirmationData = confirmations;
        await getEventHistoryData();
        initAlertTable(allMonitoringData.current);
    }

    useEffect(() => {
        if (organizationId) {
            getSitesData(organizationId);
        }
    }, [organizationId]);

    useEffect( () => {
        if (isOrganizationSelected) {
            getOrganizationFilterRulesValues();
            setDateApplied(true);
            setIsOrganizationSelected(false);
        }
    }, [isOrganizationSelected])

    useEffect( () => {
        if (dateApplied && isTableMounted) {
            getEventHistorySummaryData();
            getAllData();
        }
        setDateApplied(false);
    }, [dateApplied])

    return (<Container fluid>
        <div>
            {
                excludedPopupText === '' ?
                    <Toast
                        show={showExcludePopup}
                        autohide={true}
                        delay={1200}
                        onClose={() => setShowExcludedPopup(false)}
                        style={{
                            position: 'absolute',
                            top: '30%',
                            left: '14.5%',
                            borderRadius: '20px',
                            width: '0%',
                            height: '0%',
                            textAlign: 'center',
                            lineHeight: '10px',
                            margin: '5px',
                            color: "#28A745",
                            backgroundColor: '#28A745',
                            zIndex: 100
                        }}>
                        <Toast.Body>
                            <Card.Text>{<BsCheckCircleFill size={25}/>}</Card.Text>
                        </Toast.Body>
                    </Toast>
                    :
                    <Toast
                        show={showExcludePopup}
                        autohide={true}
                        delay={2000}
                        onClose={() => setShowExcludedPopup(false)}
                        style={{
                            position: 'absolute',
                            top: '31%',
                            left: '14.5%',
                            border: 'none',
                            boxShadow: 'none',
                            textAlign: 'center',
                            lineHeight: '10px',
                            margin: '5px',
                            color: "red",
                            backgroundColor: '#f8f9fa00',
                            zIndex: 100
                        }}>
                        <Toast.Body>
                            <Card.Text>{excludedPopupText}</Card.Text>
                        </Toast.Body>
                    </Toast>

            }
        </div>
        <Row style={{paddingTop: '1em'}}>
            <Col xs={6}>
                <Card style={{height: '173px'}}>
                    <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}>Settings</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={9}>
                                <Row>
                                    <Col md={3}>
                                        <Card.Text style={{textAlign: 'left'}}>Organization:</Card.Text>
                                    </Col>
                                    <Col md={9}>
                                        <SearchDropDown setOrganizationId={setOrganizationId}
                                                        monitoringService={monitoringService} setShowPopup={setShowPopup}
                                                        showPopup={showPopup} setSiteFilter={setSiteFilter} setIsOrganizationSelected={setIsOrganizationSelected}/>
                                        <Toast
                                            show={showPopup}
                                            onClose={() => setShowPopup(false)}
                                            style={{
                                                position: 'absolute',
                                                top: '88%',
                                                left: '1.7%',
                                                height: '75%',
                                                textAlign: 'center',
                                                lineHeight: '10px',
                                                margin: '5px',
                                                border: 'none',
                                                color: "white",
                                                backgroundColor: '#DF4957',
                                                zIndex: 100
                                            }}>
                                            <Toast.Body>
                                                <Card.Text>Organization is a required field</Card.Text>
                                            </Toast.Body>
                                        </Toast>
                                    </Col>
                                </Row>
                                <Row className='pt-2'>
                                    <Col md={3}>
                                        <Card.Text style={{textAlign: 'left'}}>Dates Range:</Card.Text>
                                    </Col>
                                    <Col md={9}>
                                        <DateRangePicker startDate={startDate} endDate={endDate} setStartDate={setStartDate}
                                                         setDateApplied={setDateApplied}
                                                         setEndDate={setEndDate}
                                                         title='leaks History'/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={2} style={{margin: 'auto'}}>
                                <Row>
                                    <Col md={6}>
                                        <OverlayTrigger placement="top" overlay={<Tooltip className="orgTooltip" style={{whiteSpace: 'nowrap'}}> {ORGANIZATION_LEVEL_FILTER_TITLE}</Tooltip>}>
                                            <Button onClick={() => {
                                                organizationId ? setOsmShow(true) : setShowPopup(true)
                                            }} variant="link" style={{color: 'black'}}><BiCog size={30}/></Button>
                                        </OverlayTrigger>
                                        <OrganizationSettingModal title={ORGANIZATION_LEVEL_FILTER_TITLE} show={osmShow} setShow={setOsmShow} flowrate={organizationLeakFlowRate} duration={organizationLeakDuration} volume={organizationLeakVolume} monitoringService={monitoringService}
                                                                  organizationId={organizationId}/>
                                    </Col>
                                    <Col md={6}>
                                        <Button onClick={async () => {
                                            if (organizationId) {
                                                setIsSetButtonClicked(true);
                                                setIsTableMounted(true);
                                                await getEventHistorySummaryData();
                                                await getAllData();
                                            } else {
                                                setShowPopup(true);
                                            }
                                        }}>SHOW</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={6}>

                <Card style={{height: '173px'}}>
                    <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}> Summary </Card.Header>
                    <Card.Body>
                        {isSummaryDataLoading ? <Spinner animation="border" variant="primary"/> :
                            <>
                                <Row>
                                    <Col md={3}>
                                        <Card.Text className='d-flex' style={{textAlign: 'left'}}>Number Of Leak Alerts:</Card.Text>
                                    </Col>
                                    <Col md={1} style={{padding: 0}}>
                                        {numberOfLeakAlerts?.toString().length >= MAX_SUMMARY_CHAR_LIMIT ?
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip>{numberOfLeakAlerts?.toLocaleString()}</Tooltip>
                                                }>
                                                <Card.Text className='text-truncate' style={{fontWeight: 'bold'}}>{numberOfLeakAlerts?.toLocaleString()}</Card.Text>
                                            </OverlayTrigger>
                                            :
                                            <Card.Text className='d-flex' style={{fontWeight: 'bold'}}>{numberOfLeakAlerts?.toLocaleString()}</Card.Text>}
                                    </Col>
                                    <Col md={{span: 5, offset: 1}}>
                                        <Card.Text style={{textAlign: 'left'}}>Total Water Consumption (L):</Card.Text>
                                    </Col>
                                    <Col md={2} style={{paddingLeft: 0}}>
                                        {totalWaterConsumption?.toString().length >= MAX_SUMMARY_CHAR_LIMIT ?
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip>{totalWaterConsumption?.toLocaleString()}</Tooltip>
                                                }>
                                                <Card.Text className='text-truncate' style={{fontWeight: 'bold'}}>{totalWaterConsumption?.toLocaleString()}</Card.Text>
                                            </OverlayTrigger>
                                            :
                                            <Card.Text className='d-flex' style={{fontWeight: 'bold'}}>{totalWaterConsumption?.toLocaleString()}</Card.Text>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Card.Text style={{textAlign: 'left'}}>Actual Leak Volume (L):</Card.Text>
                                    </Col>
                                    <Col md={1} style={{padding: 0}}>
                                        {actualLeakVolume?.toString().length >= MAX_SUMMARY_CHAR_LIMIT ?
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip>{actualLeakVolume?.toLocaleString()}</Tooltip>
                                                }>
                                                <Card.Text className='text-truncate' style={{fontWeight: 'bold'}}>{actualLeakVolume?.toLocaleString()}</Card.Text>
                                            </OverlayTrigger>
                                            :
                                            <Card.Text className='d-flex' style={{fontWeight: 'bold'}}>{actualLeakVolume?.toLocaleString()}</Card.Text>}
                                    </Col>
                                    <Col md={{span: 5, offset: 1}}>
                                        <Card.Text style={{textAlign: 'left'}}>Leak Volume Percentage:</Card.Text>
                                    </Col>
                                    <Col md={2} style={{padding: 0}}>
                                        {leakVolumePercentage?.toString().length >= 16 ?
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip>{leakVolumePercentage?.toLocaleString()}</Tooltip>
                                                }>
                                                <Card.Text className='text-truncate' style={{fontWeight: 'bold'}}>{leakVolumePercentage?.toLocaleString()}%</Card.Text>
                                            </OverlayTrigger>
                                            :
                                            <Card.Text className='d-flex' style={{fontWeight: 'bold'}}>{leakVolumePercentage?.toLocaleString()}%</Card.Text>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Card.Text style={{textAlign: 'left'}}>Potential Leak Volume (L):</Card.Text>
                                    </Col>
                                    <Col md={2} style={{paddingLeft: 0}}>
                                        {potentialLeakVolume?.toString().length >= MAX_SUMMARY_CHAR_LIMIT ?
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip>{potentialLeakVolume?.toLocaleString()}</Tooltip>
                                                }>
                                                <Card.Text className='text-truncate' style={{fontWeight: 'bold'}}>{potentialLeakVolume?.toLocaleString()}</Card.Text>
                                            </OverlayTrigger>
                                            :
                                            <Card.Text className='d-flex' style={{fontWeight: 'bold'}}>{potentialLeakVolume?.toLocaleString()}</Card.Text>}
                                    </Col>
                                    <Col md={5}>
                                        <Card.Text style={{textAlign: 'left'}}>Potential Leak Volume Percentage:</Card.Text>
                                    </Col>
                                    <Col md={2} style={{padding: 0}}>
                                        {potentialLeakVolumePercentage?.toString().length >= MAX_SUMMARY_CHAR_LIMIT ?
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip>{potentialLeakVolumePercentage?.toLocaleString()}</Tooltip>
                                                }>
                                                <Card.Text className='text-truncate' style={{fontWeight: 'bold'}}>{potentialLeakVolumePercentage?.toLocaleString()}%</Card.Text>
                                            </OverlayTrigger>
                                            :
                                            <Card.Text className='d-flex' style={{fontWeight: 'bold'}}>{potentialLeakVolumePercentage?.toLocaleString()}%</Card.Text>}
                                    </Col>
                                </Row>
                            </>
                        }
                    </Card.Body>

                </Card>
            </Col>
        </Row>
        {/* ================= Alerts History Table ================= */}
        {
            isErrorDetected ? <div style={{color: 'red'}}>{ERROR_MSG}</div>
                :
                <Row style={fadingOut ? {filter: 'blur(2px)'} : undefined} className='mt-3'>
                    <Col xs={12}>
                        <div>
                            <AlertsHistoryTable data={alertTableData}
                                                setShowExcludedPopup={setShowExcludedPopup}
                                                setExcludedPopupText={setExcludedPopupText}
                                                setAlertTableData={setAlertTableData}
                                                originalAlertTableData={originalAlertTableData}
                                                setOriginalAlertTableData={setOriginalAlertTableData}
                                                confimrationData={confirmationFilterOptions}
                                                reasonsfilterOptions={reasonsOptions}
                                                organizationId={organizationId}
                                                reasonChanged={setReasonChanged}
                                                setFadingOut={setFadingOut}
                                                filteredData={filteredData}
                                                getEventHistorySummaryData={getEventHistorySummaryData}
                                                dateApplied={dateApplied}
                                                isTableMounted={isTableMounted}
                                                setFilteredData={setFilteredData}
                                                isSetButtonClicked={isSetButtonClicked}
                                                reasons={reasonsArr}
                                                notificationLevels={notificationLevels}
                                                leakTypes={leakTypes}
                                                confirmations={confirmations}
                                                handleOnEdit={handleOnEdit}
                                                monitoringService={monitoringService}
                            />
                        </div>
                    </Col>
                </Row>
        }
    </Container>)
}
